import { render, staticRenderFns } from "./modify.vue?vue&type=template&id=730a0772&"
import script from "./modify.vue?vue&type=script&lang=js&"
export * from "./modify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports